/* global window */
'use strict';

import ApiActions from '../../actions/api';
import Constants from './constants';
import Store from './store';


class Actions {

    static registerReset(store = Store) {

        store.dispatch( {
            type: Constants.REGISTER_RESET
        });
    }
    static sendRequest(data, store = Store, cb, accountOnly) {

        store.dispatch( {
            type: Constants.CLIENT_SIDE_CHECK,
            data
        });

        const url = accountOnly ? '/api/account-only-signup' : '/api/signup';

        const state = store.getState();

        if ( !state.register.error) {
            ApiActions.post(
                url,
                data,
                store,
                Constants.REGISTER,
                Constants.REGISTER_RESPONSE,
                cb
            );
        }
    }
}


export default Actions;
